


























import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { UnifiedInsightsReportsStoreState } from './unified-insights-reports.store';
import { namespace } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';

const cssPrefix = 'product-filter';
const reportStoreModule = namespace('UnifiedInsightsReportsStoreModule');

interface FilterOptions {
  label: string;
  id: string;
  productFlag?: string;
  valueKey: string;
}

@Component({
  components: { SwTextfield, SwCheckbox },
})
export default class ProductFilter extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @reportStoreModule.Mutation
  saveToFilters: VuexMappedMutation<
    UnifiedInsightsReportsStoreState['filterData']
  >;

  @reportStoreModule.State
  filterData: UnifiedInsightsReportsStoreState['filterData'];

  optionsSelected: string[] = [];

  productOption: FilterOptions[] = [
    {
      label: this.$t('spog.unifiedInsights.firewall')
      .toString(),
      id: 'Firewall',
      productFlag: 'firewall',
      valueKey: 'firewall',
    },
    {
      label: this.$t('spog.unifiedInsights.captureClient')
      .toString(),
      id: 'Capture Client',
      productFlag: 'captureClient',
      valueKey: 'captureClient',
    },
    {
      label: this.$t('spog.unifiedInsights.wireless')
      .toString(),
      id: 'Wireless',
      productFlag: 'wireless',
      valueKey: 'wireless',
    },
  ];

  /*
    @desc returns selected options for Report product filter.
  */

  get productFilter() {
    return this.filterData ? this.filterData.product : [];
  }

  @Watch('productFilter')
  onPropertyChanged(value: string[]) {
    this.optionsSelected = value;
  }

  /*
    @desc updates selected checkbox options.
  */

  updateSelected(event: any) {
    this.optionsSelected = event;
    const obj: any = {
      product: this.optionsSelected,
    };
    this.saveToFilters(obj);
  }

  created() {
    this.optionsSelected = this.productFilter;
  }
}
